import {accountRoute} from "@/page/account/accountRoute";

export default [
  ...accountRoute,
  /**
   *
   * @param query {Object}
   * @param query.back {String}
   */
  {
    path: '/account/perfect', component: () => import('../page/account/perfect')
  },
  /**
   * 修改预留手机号
   * @param query {Object}
   * @param query.back {String}
   */
  {
    path: '/account/modify/default/phone', component: () => import('../page/account/modify/default/phone/index')
  },
  /**
   * 修改预留手机号-验证身份证
   * @param query {Object}
   * @param query.back {String}
   */
  {
    path: '/account/modify/default/phone/idcard', component: () => import('../page/account/modify/default/phone/idcard')
  },
  /**
   * 修改预留手机号-新手机号
   * @param query {Object}
   * @param query.back {String}
   */
  {
    path: '/account/modify/default/phone/phone', component: () => import('../page/account/modify/default/phone/phone')
  },
  /**
   * 修改预留手机号-ok
   * @param query {Object}
   * @param query.back {String}
   */
  {
    path: '/account/modify/default/phone/ok', component: () => import('../page/account/modify/default/phone/ok')
  }
]



// WEBPACK FOOTER //
// ./src/router/account.js